export const EsApiKeyCommands = {
  CreateESAPIKey: 'CreateESAPIKey',
  UpdateESAPIKey: 'UpdateESAPIKey',
  DeleteESAPIKey: 'DeleteESAPIKey',
  DeleteESDEXPair: 'DeleteESDEXPair',
} as const;

export const EsApiKeyActions = {
  Create: 'create',
  Update: 'update',
  Delete: 'delete',
} as const;
